import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import FearAndGreedIndexModel from "./FearAndGreedIndexModel";
import Disclaimer from "../../../components/model/Disclaimer";
import TabPanel from "../../../components/model/TabPanel";

const FearAndGreedIndex = () => {
    return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Fear & Greed Index</ModelTitle>
            <ModelInfo model={GAEventModels.FEAR_AND_GREED_INDEX}/>
            <TabPanel
                modelName={GAEventModels.FEAR_AND_GREED_INDEX}
                modelDescription={<ModelDescription>Outputs the current state of fear and greed index (using <a rel="noreferrer" target="_blank" href="https://money.cnn.com/data/fear-and-greed/">CNN</a> as a source).</ModelDescription>}
                content={<FearAndGreedIndexModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default FearAndGreedIndex;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/FearAndGreedIndex/index.tsx